
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-5'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>제품 관리 - 제품 등록</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminProductManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <!-- <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button> -->
            <button class="Admin_PageHeader_btn01" v-on:click="copy_row">복제하기</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>* "제품관리"에 등록하는 내용은 홈페이지 노출 시 서로 연결되어있습니다.</p>
            <p>* 제품 등록에서는 제품을 등록하거나 등록된 제품들을 관리할 수 있습니다. </p>
            <br>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
            <p>3. 삭제는 안되며 수정 버튼을 통해 사용여부를 미사용으로 활용하면 됩니다.</p>
            <p>4. 검색버튼을 통해 브랜드 및 제품타입을 지정해서 검색해주세요.</p>
          </div>
          <button @click="toggleSearchPanel" class="Admin_toggleSearch_openBtn">
            검색
          </button>
          <div class="Admin_toggleSearchWrap" v-if="isPanelVisible">
            <div class="Admin_toggleSearcTit">
              <p>검색조건</p>
              <button class="Admin_toggleSearch_closeBtn" @click="toggleSearchPanel"></button>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="brand_ID_product">브랜드</label>
              <select id="brand_ID_product" v-model="brandID">
                <option
                  :key="item.brand_ID"
                  v-for="item in brandData"
                  :value="item.brand_ID"
                >
                  {{item.brand_kor_name}}
                </option>
              </select>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="product_division_one_level_ID_product">제품분류(2단계)</label>
              <select id="product_division_one_level_ID_product" v-model="productDivisionOneLevelID">
                <option
                  :key="item.product_division_one_level_ID_product"
                  v-for="item in productDivisionOneLevelData"
                  :value="item.product_division_one_level_ID_product"
                >
                  {{item.product_division_one_level_kor_name}}
                </option>
              </select>
            </div>
            <button @click="fetchDataWithParams" class="Admin_toggleSearch_searchBtn">검색</button>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_product,
  update_product_order,
  delete_product,
  copy_product,
  get_brand,
  get_product_division_one_level_brand_ID
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminProductManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      isPanelVisible: false,
      brandID: '',
      productDivisionOneLevelID: '',
      brandData: [],
      productDivisionOneLevelData: [],
      isInitialLoad: true // 초기 로드 여부를 확인하는 플래그
    }
  },
  watch: {
    brandID: function (newBrandID) {
      if (this.isInitialLoad) return // 초기 로드 시에는 실행하지 않음
      get_product_division_one_level_brand_ID(newBrandID).then(result_data_one_level => {
        this.productDivisionOneLevelData = result_data_one_level
        if (result_data_one_level.length > 0) {
          this.productDivisionOneLevelID = result_data_one_level[0].product_division_one_level_ID_product
        } else {
          this.productDivisionOneLevelID = ''
        }
        this.fetchDataWithParams()
      })
    },
    productDivisionOneLevelID: function () {
      if (this.isInitialLoad) return
      this.fetchDataWithParams()
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminProductManagementAdd?product_ID=${this.tabulator.getSelectedData()[0].product_ID}`
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.product_ID)
      })
      delete_product(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    },
    copy_row: function () {
      let temp_copy_array = []
      if (this.tabulator.getSelectedData().length === 0) {
        alert('복제할 리스트를 선택해주세요.')
      } else {
        this.tabulator.getSelectedData().forEach((element) => {
          temp_copy_array.push(element.product_ID)
        })
        copy_product(JSON.stringify(temp_copy_array)).then((result) => {
          if (result === undefined) {
            alert('복제가 되지 않았습니다. 관리자한테 확인해주세요.')
          } else {
            alert('복제가 완료 되었습니다.')
            window.location.reload()
          }
        })
      }
    },
    toggleSearchPanel: function () {
      this.isPanelVisible = !this.isPanelVisible
    },
    fetchDataWithParams: function () {
      const params = {
        brand_ID_product: this.brandID,
        product_division_one_level_ID_product: this.productDivisionOneLevelID
      }
      get_product(params).then(result_data => {
        this.tabulator.setData(result_data)
        this.tabulator.setPage(1)
      })
    }
  },
  mounted () {
    get_brand().then(result_data_brand => {
      this.brandData = result_data_brand
      this.brandID = this.$route.query.brand_ID_product ? this.$route.query.brand_ID_product : result_data_brand[0].brand_ID
      get_product_division_one_level_brand_ID(this.brandID).then(result_data_one_level => {
        this.productDivisionOneLevelData = result_data_one_level
        this.productDivisionOneLevelID = this.$route.query.product_division_one_level_ID_product ? this.$route.query.product_division_one_level_ID_product : result_data_one_level[0].product_division_one_level_ID_product
        const params = {
          brand_ID_product: this.brandID,
          product_division_one_level_ID_product: this.productDivisionOneLevelID
        }
        get_product(params).then(result_data => {
          this.tabulator = new Tabulator(this.$refs.table, {
            data: result_data,
            layout: 'fitData',
            movableRows: true,
            columns: [
              {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
              {formatter: 'rowSelection',
                titleFormatter: 'rowSelection',
                headerSort: false,
                cellClick: function (e, cell) {
                  cell.getRow().toggleSelect()
                }
              },
              {title: 'ID', field: 'product_ID', headerSort: false},
              {title: '브랜드명', field: 'brand_kor_name', headerSort: false},
              {title: '제품타입명(1단계)', field: 'product_type_kor_name', headerSort: false},
              {title: '제품분류(2단계)', field: 'product_division_one_level_kor_name', headerSort: false},
              {title: '제품분류(3단계)', field: 'product_division_two_level_kor_name', headerSort: false},
              {title: '한글명', field: 'product_kor_name', headerSort: false},
              {title: '영문명', field: 'product_eng_name', headerSort: false},
              {title: '사용 여부', field: 'product_activate', headerSort: false},
              {title: '이벤트 여부', field: 'product_event', headerSort: false},
              {title: '등록 일자', field: 'product_registe', headerSort: false},
              {title: '수정 일자', field: 'product_modified', headerSort: false}
            ]
          })
          this.tabulator.on('rowMoved', function (row) {
            let temp_product_order_array = []
            let product_order = 0
            const table = row.getTable()
            table.getRows().forEach(element => {
              temp_product_order_array.push({
                product_order: product_order,
                product_ID: element._row.data.product_ID
              })
              product_order++
            })
            update_product_order(temp_product_order_array).then(result => {
              if (result === undefined) {
                alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
              }
            })
          })
          this.isInitialLoad = false
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminProductManagement.vue